import { LayoutTemplate, Smartphone, Sparkles, Layers, ShoppingBag, Cloud } from 'lucide-react';

const SERVICES = [
  {
    short: 'Web platforms', lower: 'web platforms', icon: LayoutTemplate,
    title: 'Custom web platforms',
    desc: 'Portals, internal tools and marketplaces built for real traffic, with tests and monitoring from the first sprint.',
    items: ['Customer portals and internal tools', 'Role-based access and audit logs', 'Automated tests and monitoring'],
    tags: ['React', 'Next.js', 'Node', 'Django'],
    image: '/images/svc-web.jpg', alt: 'Service visual: web platforms',
  },
  {
    short: 'Mobile', lower: 'mobile', icon: Smartphone,
    title: 'Mobile apps',
    desc: 'One codebase for iOS and Android, native where it matters. Offline sync, push and store releases included.',
    items: ['iOS and Android from one codebase', 'Offline sync and push notifications', 'App Store and Play releases'],
    tags: ['React Native', 'Flutter'],
    image: '/images/svc-mobile.jpg', alt: 'Service visual: mobile',
  },
  {
    short: 'AI & LLM', lower: 'AI', icon: Sparkles,
    title: 'AI and LLM solutions',
    desc: 'Agents, RAG search, assistants and document automation on your own data, with evaluations and cost limits.',
    items: ['Retrieval over your documents (RAG)', 'Agents that call your own APIs', 'Evaluations, guardrails and cost limits'],
    tags: ['Agents', 'RAG', 'Assistants', 'Model integration'],
    image: '/images/svc-ai.jpg', alt: 'Service visual: AI and LLM',
  },
  {
    short: 'SaaS', lower: 'SaaS', icon: Layers,
    title: 'SaaS products',
    desc: 'From first version to multi-tenant platform: accounts, roles, billing and dashboards customers run themselves.',
    items: ['Multi-tenant accounts and roles', 'Subscriptions and billing', 'Admin and customer dashboards'],
    tags: ['Multi-tenant', 'Billing', 'Dashboards'],
    image: '/images/svc-saas.jpg', alt: 'Service visual: SaaS',
  },
  {
    short: 'E-commerce', lower: 'e-commerce', icon: ShoppingBag,
    title: 'E-commerce',
    desc: 'Headless storefronts, custom checkout and ERP or PIM integrations that keep stock levels honest.',
    items: ['Headless storefronts', 'Custom checkout and payments', 'ERP and PIM integrations'],
    tags: ['Headless', 'Checkout', 'Integrations'],
    image: '/images/svc-ecommerce.jpg', alt: 'Service visual: e-commerce',
  },
  {
    short: 'Cloud & DevOps', lower: 'cloud & devops', icon: Cloud,
    title: 'Cloud and DevOps',
    desc: 'Infrastructure as code, CI/CD and alerting, so releases are routine and outages are short.',
    items: ['Infrastructure as code', 'CI/CD pipelines', 'Alerting and on-call runbooks'],
    tags: ['AWS', 'Azure', 'GCP', 'CI/CD'],
    image: '/images/svc-cloud.jpg', alt: 'Service visual: cloud and DevOps',
  },
];
export default SERVICES;
